// extracted by mini-css-extract-plugin
export default {"kpi":"Kpi_kpi__1wZSQ","svg":"Kpi_svg__bXSR9","details":"Kpi_details__lgdfk"};